document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-ws-faq]').forEach(function (faq) {
    faq.addEventListener('toggle', function () {
      if (faq.open && window.dataLayer) {
        window.dataLayer.push({
          event: 'landing_page_faq_opened',
          faq_question: faq.querySelector('summary')?.textContent?.trim() || ''
        });
      }
    });
  });
});
